import $ from 'jquery'

let $main

export function initialise() {
  $main = $('#tessitura-content')

  if (!$main.length) {
    return
  }

  injectSections()

  removeStylesheet()
  removeTableBorders()
  transformHeadings()
  transformButtons()
  transformLabels()
  transformInputs()
  transformSelects()
  transformCalendarNavigation()
  transformFontSize()
  transformCheckbox()
  transformRequired()
}

function injectSections() {
  const $target = $('[data-tessitura-sections]')
  const script = $target.attr('data-tessitura-sections')
  const url = script + '?url=' + window.encodeURIComponent(window.location.href)
  $target.load(url)
}

// remove TNEW stylesheet because and let Turret shine through the cracks
function removeStylesheet() {
  $('link[href$="TNEW.css"]').remove()
}

// remove borders and padding from tables that Turret adds
function removeTableBorders() {
  $('#tnew-site-table-wrapper, #tnew-site-cell-wrapper').css('border', 0)

  $('.tn-block-table').css('border', 0)
  $('.tn-block-table>tbody>tr>td').css({
    border: 0,
    paddingLeft: 0,
    paddingRight: 0,
  })
}

function transformHeadings() {
  // make .huge.c1 headings look like h1
  $('.huge.c1', $main)
    .addClass('h1')
    .removeClass('huge c1')
}

function transformButtons() {
  // add Turret button styling
  $('.btnStyle', $main)
    .addClass('button inline-flex')
    .css('width', 'auto')
    .removeClass('btnStyle')

  // Submit buttons to be primary
  $('input[type="submit"]', $main).addClass('button-primary')
}

function transformLabels() {
  // override Turret's "inherit" value
  $('label:not([class])', $main)
    .css('color', 'currentColor')
    .addClass('font-size-s')
    .css('fontWeight', 'initial')
}

function transformInputs() {
  // override Turret's "inherit" value
  $('input[type!="submit"]', $main).css('fontWeight', 'initial')
}

function transformSelects() {
  // wrap selects with label for Turret
  $('select:visible', $main)
    .css('paddingRight', '2rem')
    .wrap('<label class="select inline-flex" />')

  // override Turret's "inherit" value
  $('select', $main).css('fontWeight', 'initial')
}

function transformCalendarNavigation() {
  const $cal = $('.tn-calendar__container', $main)

  $('.select', $cal).addClass('select-s')
  $('#btn-prev, #btn-next', $cal).addClass('button-s button-dark button-square')
}

function transformFontSize() {
  $('font[size="1"]')
    .removeAttr('size')
    .addClass('font-size-s')
    .css('fontWeight', 'initial')
}

function transformCheckbox() {
  $('.tnew-checkbox')
    .css('marginRight', '8px')
    .addClass('font-size-s')
    .css('fontWeight', 'initial')
}

function transformRequired() {
  $('.TNEW_required')
    .addClass('font-family')
    .addClass('font-weight-medium')
    .addClass('font-size-s')
    .addClass('color-dark')
}
